document.addEventListener('DOMContentLoaded', function() {
  const copyBtn = document.getElementById('copyPromoBtn');
  const tooltip = document.getElementById('copyTooltip');

  if (copyBtn) {
    copyBtn.addEventListener('click', function() {
      const codeToCopy = this.getAttribute('data-code');
      
      navigator.clipboard.writeText(codeToCopy).then(() => {
        // Показуємо підказку "Скопійовано!"
        tooltip.classList.add('show');
        
        // Ховаємо її назад через 2 секунди
        setTimeout(() => {
          tooltip.classList.remove('show');
        }, 2000);
      }).catch(err => {
        console.error('Не вдалося скопіювати код: ', err);
      });
    });
  }
});